/*
 * @Author: hehaishen
 * @Date: 2019-05-05 14:34:58
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2019-12-24 18:08:33
 * @Description: 
 */
const routerArr = [
    {
        path: 'productManage',
        component: (resolve) => require(["page/intelligentDevice/productManage/index.vue"], resolve),
        meta: { show: '1110', title: '电梯管理', source: '11b8' },
    },
    {
        path: 'productManage/particulars',
        component: (resolve) => require(["page/intelligentDevice/productManage/particulars.vue"], resolve),
        meta: { show: '1110', title: '电梯管理详情', source: '11b8' },
    },
    {
        path: 'newOTAManage',
        component: (resolve) => require(["page/intelligentDevice/OTAManage/index.vue"], resolve),
        meta: { show: '1110', title: 'OTA管理', source: '11b8' }
    },
    {
        path: 'newSIMManage',
        component: (resolve) => require(["page/intelligentDevice/SIMManage/index.vue"], resolve),
        meta: { show: '1110', title: 'SIM卡管理', source: '11b8' }
    },
    {
        path: 'deviceManage',
        component: (resolve) => require(["page/intelligentDevice/deviceManage/index.vue"], resolve),
        meta: { show: '1110', title: '设备管理', source: '11b8' }
    },
    {
        path: 'deviceManage/deviceSet',
        component: (resolve) => require(["page/intelligentDevice/deviceManage/deviceSet.vue"], resolve),
        meta: { show: '1110', title: '设备设置', source: '11b8' }
    },
    {
        path: 'modelManage',
        component: (resolve) => require(["page/intelligentDevice/modelManage/index.vue"], resolve),
        meta: { show: '1110', title: '模型管理', source: '11b8' }
    },
    {
        path: 'qualityTest',
        component: (resolve) => require(["page/intelligentDevice/qualityTest/index.vue"], resolve),
        meta: { show: '1110', title: '终端质检', source: '11b8' }
    },
    {
        path: 'deviceManagementTextList',
        name: 'deviceManagementTextList',
        component: (resolve) => require(["page/intelligentDevice/deviceTest/index.vue"], resolve),
        meta: { show: '1110', title: '设备文件', source: '11b8' }
    },
     //协议模板
    {
        path: 'protocolsTemplateList',
        name: 'protocolsTemplateList',
        component: (resolve) => require(["page/intelligentDevice/protocolTemplate/index.vue"], resolve),
        meta: { show: '1110', title: '协议模板', source: '11b8' }
    },
    //协议模板--详情
    {
        path: 'protocolsTemplateList/protocolsTemplateDetail',
        name: 'protocolsTemplateDetail',
        component: (resolve) => require(["page/intelligentDevice/protocolTemplate/addEditDetail"], resolve),
        meta: { show: '1110', title: '协议模板详情新增编辑', source: '11b8' }
    },
    {
        path: 'deviceUpgrade',
        name: 'deviceUpgrade',
        component: (resolve) => require(["page/intelligentDevice/deviceUpgrade/index.vue"], resolve),
        meta: { show: '1110', title: '设备升级', source: '11b8' }
    },

];

export default routerArr;


// WEBPACK FOOTER //
// ./src/container/pages/intelligentDevice/_res.js